import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { receive } from "common/reducers/Utils";
import { emailFromJSON, EmailRecord } from "common/records/Email";
import { EmailActions, RECEIVE_EMAIL, RECEIVE_EMAILS } from "common/reducers/email.actions";

export const EmailStateRecord = Record({
  lastSavedById: Map<number, EmailRecord>(),
  byId: Map<number, EmailRecord>(),
});

export const initialState = EmailStateRecord();

const model = "emails";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_EMAIL:
      return receive(state, model, emailFromJSON(action.payload.email));

    case RECEIVE_EMAILS:
      action.payload.emails.forEach((email) => {
        state = reducer(state, EmailActions.receiveEmail(email));
      });
      return state;

    default:
      return state;
  }
};
